// extracted by mini-css-extract-plugin
module.exports = {"container":"ListPlaceholder_container__2lYeQ"};